// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PersonRef } from './personRef.zod.ts';

export const PromptVersionOut = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([PersonRef,zod.null()]),
  "id": zod.uuid(),
  "is_current": zod.boolean(),
  "note": zod.string(),
  "run_count": zod.int(),
  "version": zod.int()
});

export type PromptVersionOut = zod.input<typeof PromptVersionOut>;
export type PromptVersionOutOutput = zod.output<typeof PromptVersionOut>;
